'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextareaGroup = require('./TextareaGroup');

Object.defineProperty(exports, 'TextareaGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextareaGroup).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/textareaGroup/index.js
// module id = 619
// module chunks = 0